import { DateTime } from "luxon";

export function calcDayDiff(day: string, target: string): number {
  return DateTime.fromISO(day)
    .startOf("day")
    .diff(DateTime.fromISO(target).startOf("day"), "days").days;
}
